import { css, LayoutHerodias, LayoutJay, styled } from "@lux/ds";

export const StyledJay = styled(LayoutJay)`
  height: calc(100vh - 64px);
  width: calc(100vw - 280px);
  min-width: 1152px;
`;

export const InPageStyledJay = styled(LayoutJay)`
  height: calc(100vh - 64px);
  min-width: 1152px;
`;

export const StyledHeader = styled(LayoutHerodias)(
  ({ theme }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.palette.primary.shade[80]};
    height: ${theme.space["4xl"]};
    justify-content: space-between;
    padding: ${theme.space.m};
  `,
);

export const StyledThumbnailContainer = styled(LayoutHerodias)(
  ({ theme }) => css`
    &::-webkit-scrollbar {
      display: none;
    }

    border-right: 1px solid ${theme.palette.primary.shade[80]};
    flex-direction: column;
    height: 100%;
    gap: ${theme.space.s};
    padding: ${theme.space.s};
    width: 215px;
  `,
);

export const StyledThumbnailItem = styled(LayoutJay, {
  shouldForwardProp: (prop) => prop !== "$selected",
})<{ $selected: boolean }>(
  ({ $selected, theme }) => css`
    border: 1px solid
      ${$selected
        ? theme.palette.primary.shade[10]
        : theme.palette.primary.shade[80]};
    border-radius: ${theme.space.xxs};
    cursor: pointer;
    gap: ${theme.space.xs};
    padding: ${theme.space.s};
    width: 100%;
  `,
);

export const StyledSliderContainer = styled(LayoutHerodias)(
  ({ theme }) => css`
    padding: ${theme.space.m};
    width: calc(100% - 215px);

    & div {
      grid-template-rows: 1fr !important;
    }
  `,
);

export const StyledLoaderContainer = styled(LayoutHerodias)`
  flex: 1;
  justify-content: center;
`;

export const GalleryContainer = styled(LayoutHerodias)(
  ({ theme }) => css`
    background-color: ${theme.palette.primary.shade[100]};
  `,
);
